export function contactBlockFiltering() {
    const contactBlockFilters = document.querySelectorAll(".pul-contacts-block [data-contact-filter]");
    const contactBlockItems = document.querySelectorAll(".pul-contacts-block [data-filter]");

    if (contactBlockFilters.length > 0 && contactBlockItems.length > 0) {
        for (const contactBlockFilter of contactBlockFilters) {
            contactBlockFilter.addEventListener("click", () => {
                // remove active class from all filters
                contactBlockFilter.closest(".filter-container").querySelector(".active").classList.remove("active");

                // add active class
                contactBlockFilter.classList.add("active");

                // filter contacts based on the clicked filter
                const filter = contactBlockFilter.getAttribute("data-contact-filter");
                
                for (const contactItem of contactBlockItems) {
                    if (contactItem.dataset.filter === filter || filter === "all") {
                        contactItem.classList.remove("hidden");
                    } else {
                        contactItem.classList.add("hidden");
                    }
                }
            })
        }
    }
}